import React from 'react';
import { Table } from '@tanstack/react-table';
import { TableCard } from './TableCard';
import { SimpleTableHeader } from './Headers';
import { SimpleTableBody } from './Bodies';

export interface SimpleTableTWProps<T> {
  table: Table<T>;
  headerTitle?: string;
}

// A simple no-frills table with styling by Tailwind. This is the start of our exploration with the TanStack Table.
export function SimpleTableTW<T>({ table, ...rest }: SimpleTableTWProps<T>) {
  return (
    <>
      <TableCard>
        <SimpleTableHeader table={table} {...rest} />
        <SimpleTableBody table={table} />
      </TableCard>
    </>
  );
}
